<div id="date-range-selection-container">
  <form [formGroup]="dateSelectionForm" class="date-range-selection-form">
    <mat-form-field id="date-range-selection-input" appearance="outline">
        <mat-label>Select Date Range</mat-label>
        <mat-select formControlName="periodSelect" >
            <mat-option *ngFor="let period of dateRangeList" [value]="period"   [class.selected]="selectedDateRange?.description === period.description"
            (click)="onSelect(period)" id="dateRangeSelect">
                {{period.description}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>
</div>
